import React, { useEffect, useRef, useState } from "react";
import Calendar from "components/crm/ui/Calendar";
import Label from "components/crm/ui/Label";
import useCloseOnEscape from "components/crm/ui/useCloseOnEscape";
import {
  dayLabel,
  fromIsoDay,
  isoDay,
  useCrmLocale,
} from "components/crm/ui/crmTime";
import useText from "hooks/useText";

// Date field ("Thu. 8 Oct.") that opens the calendar. value: YYYY-MM-DD.
const DateField = ({ id, label, value, onChange, minDate, up, placeholder }) => {
  const { text } = useText("crmUi");
  const locale = useCrmLocale();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) =>
      ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  useCloseOnEscape(open, () => setOpen(false));
  const d = value ? fromIsoDay(value) : null;
  return (
    <div ref={ref} className="relative flex flex-col gap-2">
      {label && <Label htmlFor={id}>{label}</Label>}
      <button
        id={id}
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`rounded-lg border bg-white p-3 text-left text-sm font-medium transition-colors ${
          open ? "border-primary" : "border-lineStrong hover:border-faint"
        } ${d ? "text-ink" : "text-faint"}`}
      >
        {d ? dayLabel(d, locale) : placeholder ?? text("chooseDay")}
      </button>
      {open && (
        <div
          className={`absolute left-0 z-30 ${
            up ? "bottom-full mb-2" : "top-full mt-2"
          }`}
        >
          <Calendar
            value={d}
            minDate={minDate ?? new Date(2000, 0, 1)}
            onChange={(day) => {
              onChange(isoDay(day));
              setOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DateField;
